import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import ChooseIndustryModal from '../Modals/ChooseIndustryModal'
import SurveySearchStore from './SurveySearchStore'
import SearchLayout from '../Layouts/Search'
import Select from '../form/Select'
import DataTable from '../DataTable'
import Checkbox from '../form/Checkbox'
import Button from '../../UniformComponents/Button'
import LinkButton from '../../UniformComponents/LinkButton'
import AppLoading from '../AppLoading'
import SurveyLicenceModal from '../Modals/SurveyLicenceModal'
import NoLicenceModal from '../Modals/NoLicenceModal'

@observer
class SurveySearch extends Component {
    constructor(props) {
        super(props)
        this.surveySearchStore = new SurveySearchStore(props.store)
        this.state = {
            loading: true,
        }
        this.surveySearchStore.setColumns(props.surveySearchType, props.store)
    }

    async componentDidMount() {
        const { store, location, surveySearchType } = this.props
        const query = new URLSearchParams(location.search)
        const isReportOrDirectorUser = this.permissionCheck(['150', '170'])
        store.breadcrumps = [
            {
                name: isReportOrDirectorUser ? 'report' : 'survey',
                url: isReportOrDirectorUser ? '/report' : '/survey',
                title: isReportOrDirectorUser ? 'Report' : 'Survey',
            },
        ]
        await this.surveySearchStore.init(query, surveySearchType)
        this.setState({ loading: false })
    }

    permissionCheck = (allowedRoles) => {
        const { store } = this.props
        const currentUserRole = store.tokenData.roles
        return allowedRoles.some((role) => currentUserRole.includes(role))
    }

    renderFilterOptions = () => {
        const { surveySearchStore } = this
        const { respondentTypes, surveyTypes, productTypes } = surveySearchStore
        const { surveySearchType } = this.props
        return (
            <Fragment>
                <br />

                <fieldset className="filter">
                    <Select
                        label={i18n.t('event', 'Event')}
                        options={surveySearchStore.products}
                        onBlur={surveySearchStore.changeProduct}
                        value={surveySearchStore.product}
                    />
                </fieldset>

                <br />

                <fieldset className="filter">
                    <Select
                        label={i18n.t('year', 'Year')}
                        options={surveySearchStore.years}
                        onBlur={surveySearchStore.changeYear}
                        value={surveySearchStore.year}
                    />
                </fieldset>
                <fieldset className="filter">
                    <legend className="legend-title">
                        {surveySearchType === 'maxbi' ? 'Maxbi status' : `${i18n.t('status', 'Status')}`}
                    </legend>
                    <div>
                        {(surveySearchStore.statuses.map(
                            (status) => (
                                <Checkbox
                                    onBlur={surveySearchStore.toggleStatus}
                                    checked={
                                        surveySearchStore.status.find((s) => (s === status.value))
                                    }
                                    name={status.value}
                                    label={status.label}
                                />
                            ),
                        ))}
                    </div>
                </fieldset>
                {surveySearchType === 'maxbi' ? null
                    : (
                        <>
                            <fieldset className="filter">
                                <legend className="legend-title">
                                    {i18n.t('survey_type')}
                                </legend>
                                <div>
                                    {Object.keys(surveyTypes)
                                        .map((surveyType) => (
                                            <Checkbox
                                                onBlur={surveySearchStore.toggleSurveyType}
                                                checked={surveyTypes[surveyType].selected}
                                                name={surveyType}
                                                label={surveyTypes[surveyType].name}
                                            />
                                        ))}
                                </div>
                            </fieldset>
                            <fieldset className="filter">
                                <legend className="legend-title">
                                    {i18n.t('respondent_type')}
                                </legend>
                                <div>
                                    {Object.keys(respondentTypes)
                                        .map((respondentType) => (
                                            <Checkbox
                                                onBlur={surveySearchStore.toggleRespondentType}
                                                checked={respondentTypes[respondentType].selected}
                                                name={respondentType}
                                                label={respondentTypes[respondentType].name}
                                            />
                                        ))}
                                </div>
                            </fieldset>
                            <fieldset className="filter">
                                <legend className="legend-title">
                                    {i18n.t('product_type')}
                                </legend>
                                <div>
                                    {Object.keys(productTypes)
                                        .map((pt) => (
                                            <Checkbox
                                                onBlur={surveySearchStore.toggleProductType}
                                                checked={productTypes[pt].selected}
                                                name={pt}
                                                label={productTypes[pt].name}
                                            />
                                        ))}
                                </div>
                            </fieldset>
                        </>
                    )}
            </Fragment>
        )
    }

    renderButtons = () => {
        const { surveySearchType } = this.props
        const { surveySearchStore } = this
        switch (surveySearchType) {
            case 'survey': return (
                <Button
                    cssClass="add-button primary regular"
                    onClick={surveySearchStore.handleCreateSurvey}
                    icon="fa-light fa-circle-plus"
                    label={i18n.t('add_survey', 'Add new survey')}
                    disabled={this.surveySearchStore.industries.length === 0}
                />
            )
            case 'maxbi': return (
                <LinkButton
                    cssClass="primary regular"
                    href="/survey/0/CE?surveytype=EM"
                    icon="fa-light fa-circle-plus"
                    label={i18n.t('maxbiSearch.button.newMaxbiEntry', 'New Maxbi Entry')}
                    isExternal
                />
            )
            default: return null
        }
    }

    renderTablePanel = () => {
        const { surveySearchStore } = this
        return (
            <DataTable
                store={surveySearchStore}
                inMemory
                dataSet={surveySearchStore.filteredList || []}
                columns={surveySearchStore.columns}
                cssClass="search-table"
            />
        )
    }

    renderGuide = () => (
        <div dangerouslySetInnerHTML={{
            __html: i18n.t('surveySearch.introText'),
        }}
        />
    )

    render() {
        const { surveySearchType } = this.props
        const { loading } = this.state
        const { surveySearchStore } = this

        return (
            <Fragment>
                {!loading
                    ? (
                        <SearchLayout
                            pageTitle={surveySearchStore.searchSurveyType[surveySearchType]}
                            renderFilterOptions={this.renderFilterOptions}
                            renderButtons={this.renderButtons}
                            renderTablePanel={this.renderTablePanel}
                            renderGuide={this.renderGuide}
                            searchStore={surveySearchStore}
                        />
                    ) : <AppLoading noBg showTypewriter customMessage="Fetching your surveys..." />}

                <ChooseIndustryModal
                    industryChooseOpen={surveySearchStore.showChooseIndustry}
                    openCreateItem={surveySearchStore.openNewSurvey}
                    toggleIndustryChoose={surveySearchStore.closeIndustryChoose}
                    industries={surveySearchStore.industries}
                />

                <NoLicenceModal
                    store={surveySearchStore}
                />

                <SurveyLicenceModal
                    store={surveySearchStore}
                />
            </Fragment>
        )
    }
}

export default SurveySearch
